import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import DialogModal from 'components/Dialog';
import ToastWrapper from 'components/Toast';
import { isEmbed, ROUTE_PATH } from 'routes';
import {
  createBrowserRouter, Navigate, Outlet, RouterProvider,
} from 'react-router-dom';
import ErrorBoundary from 'components/ErrorBoundary';
import { useSelector } from 'react-redux';
import { useSessionRoutes } from '../hooks/useSessionRoutes';
import RenderView from './RenderView';

function App(props) {
  const {
    isAuthenticated,
    user,
    platform,
    setGlobalProperties,
    sessionChecked,
    initPlatform,
  } = props;

  const loading = useSelector(state => state.global.loading);
  const sessionRoutes = useSessionRoutes(sessionChecked, isAuthenticated, user, platform, initPlatform);

  if ((isAuthenticated ? !user?.role?.length : !platform.loaded)
    || loading || !sessionChecked) return <Loading />;

  const routes = [
    ...sessionRoutes.map(route => ({
      path: route.path,
      element: (
        <RenderView
          user={user}
          setGlobalProperties={setGlobalProperties}
          route={route}
          isAuthenticated={isAuthenticated}
          platform={platform}
        />
      ),
    })),
    {
      path: '*',
      element: (
        <Navigate
          replace
          to={{
            pathname: isAuthenticated || isEmbed()
              ? ROUTE_PATH.NOT_FOUND
              : ROUTE_PATH.LOGIN,
          }}
        />
      ),
    },
  ];

  return (
    <RouterProvider
      fallbackElement={<Loading />}
      router={createBrowserRouter([{
        path: '',
        element: (
          <ErrorBoundary>
            <DialogModal />
            <ToastWrapper />
            <Outlet />
          </ErrorBoundary>
        ),
        children: routes,
      }])}
    />
  );
}

App.propTypes = {
  sessionChecked: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  platform: PropTypes.object.isRequired,
  initPlatform: PropTypes.func.isRequired,
  setGlobalProperties: PropTypes.func.isRequired,
};

export default App;
